export default function () {
  var accountRow = $('#project_account').parents('.form-group');

  $('#project_billingType').change(function() {
    if ($(this).val() == 3) {
      accountRow.hide();
      return;
    }

    accountRow.show();
  });
};



// WEBPACK FOOTER //
// ./assets/js/create-project.js